import {ControlPosition, MapControl, useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {useEffect, useState} from "react";
import projectUtils from "../../utils/project-utils.js";
import InputForm from "../input/input-form.jsx";
import Button from "../button/button.jsx";
import {FaSearch} from "react-icons/fa";

export const GeocodeAddress = ({address, changeLocation, parsedLatitude, parsedLongitude, position}) => {
    const map = useMap();
    const geocoding = useMapsLibrary('geocoding');
    const [search, setSearch] = useState(projectUtils.addressToString(address?.city, address?.neighborhood, (address?.street ?? address?.address), address?.number));
    const hasValidCoordinates = Number.isFinite(parsedLatitude) && Number.isFinite(parsedLongitude);

    useEffect(() => {
        if (!map || !position) return;

        map.setCenter(position);
    }, [map, position]);

    useEffect(() => {
        if (!geocoding || !address) return

        if (!hasValidCoordinates &&
            (address?.city || address?.neighborhood || address?.address || address?.number)) onClick()
    }, [geocoding, address, hasValidCoordinates]);

    const onClick = () => {
        if (!address) return;

        const geocoder = new geocoding.Geocoder();
        geocoder.geocode({'address': search}, function (results, status) {
            if (status === 'OK') {
                map.setZoom(14);
                map.setCenter(results[0].geometry.location);
                changeLocation(results[0].geometry.location);
            }
        });
    }

    return (
        <MapControl position={ControlPosition.LEFT_TOP}>
            <div className="flex gap-1 p-[10px]">
                <InputForm
                    classNameWrapper={"w-2xs print:hidden"}
                    inputClass={"!bg-white"}
                    value={search}
                    type={"search"}
                    onChange={({target}) => setSearch(target.value)}
                />

                <Button target={"primary"} onClick={onClick} className="print:hidden">
                    <FaSearch />
                </Button>
            </div>
        </MapControl>
    )
}
